import { createStyles, makeStyles, Theme, createTheme } from '@material-ui/core/styles';

export const TableBaseStyle = makeStyles(
    createStyles({
        //テーブル外枠
        tableStyle: {
            borderWidth: '1px',
            borderColor: '#dcdcdc',
            borderStyle: 'solid',
        },
        //テーブルヘッダセル
        headerCell: {
            borderWidth: '1px',
            borderColor: '#dcdcdc',
            borderStyle: 'solid',
            backgroundColor: 'grey',
            textAlign: 'center',
            color: 'white',
            padding: '1px',
            borderCollapse: `collapse`,
        },
        bodyCell: {
            borderWidth: '1px',
            borderColor: '#dcdcdc',
            borderStyle: 'solid',
            textAlign: 'center',
            height: '15px',
        },
        bodyCell_left: {
            borderWidth: '1px',
            borderColor: '#dcdcdc',
            borderStyle: 'solid',
            textAlign: 'left',
            paddingleft: 2,
            height: '15px',
        },
        tableContainer: {
            maxHeight: 'calc(100vh - 270px)',
            overflowX: 'scroll',
        },
        tableCell: {
            borderWidth: '1px',
            borderColor: '#FFFFEE',
            borderStyle: 'solid',
            padding: '0px 0px 0px 4px',
            borderBottomWidth: '0px',
        },
        itemBoxStyle: {
            fontSize: '13px',
        },
        button: {
            maxWidth: '180px',
            maxHeight: '45px',
            marginTop: '5px',
            marginLeft: '40px',
            alignItems: 'center',
        },
        manualButton: {
            maxWidth: '150px',
            maxHeight: '35px',
            minWidth: '150px',
            minHeight: '35px',
            marginTop: '5px',
            alignItems: 'center',
            color: "Green",
            borderColor: 'white',
        },
    })
);